import React from "react";
import { Text, Flex } from "@fluentui/react-northstar";
import styles from "./rankItem.module.scss";

interface RankItemProps {
    header?: string;
    children: React.ReactNode;
}

const RankItem: React.FC<RankItemProps> = (props: RankItemProps) => {
    return (
        <Flex column>
            <Text size="smaller" weight="semibold" className={styles.header}>
                {props.header}
            </Text>
            {props.children}
        </Flex>
    );
};

export default RankItem;
